import {
    DELETE_AWARD_REQUEST,
    DELETE_AWARD_SUCCESS,
    DELETE_AWARD_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const deleteAwardReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_AWARD_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case DELETE_AWARD_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case DELETE_AWARD_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default deleteAwardReducer;
